module.exports = __webpack_public_path__ + "c188df5c81773613e97cd7b2a039f91e.svg";